import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import {Link} from "react-router-dom";



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class NoChats extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        const { t } = this.props;

            return (
                <>
                    <div className="no-chats">
                        <h2>No ongoing chats</h2>
                        <p> Why not see who's on your website right now and start a chat proactively?</p>
                        <Link className="btn btn-primary btn-sm" to={"/traffic"}>
                            Traffic
                        </Link>

                    </div>
                </>
            )

    }
}

export default withTranslation()(NoChats);




